import { getFullName } from "helpers";

export const tidEquipmentStatuses = {
	unassigned: "unassigned",
	inProgress: "in-progress",
	pended: "pended",
	complete: "complete",
	qaUnassigned: "qa-unassigned",
	qaInProgress: "qa-in-progress",
	qaComplete: "qa-complete",
};

export const pendStatus = {
	RESPONSE_SUBMITTED: "response_submitted",
	REOPEN: "reopen",
	CLOSED: "closed",
	OPEN: "open",
};

export const tidEquipmentTabs = {
	[tidEquipmentStatuses.unassigned]: "Unassigned",
	[tidEquipmentStatuses.inProgress]: "In Progress",
	[tidEquipmentStatuses.pended]: "Pended",
	[tidEquipmentStatuses.complete]: "Complete",
	[tidEquipmentStatuses.qaUnassigned]: "QA Unassigned",
	[tidEquipmentStatuses.qaInProgress]: "QA In Progress",
	[tidEquipmentStatuses.qaComplete]: "QA Complete",
};

export const mapMerchantDataFromServer = merchant => {
	return {
		agent: getFullName?.(merchant?.agent),
		agentId: merchant?.agent_id,
		agentOffice: merchant?.agent_office?.name,
		agentOfficeId: merchant?.agent_office_id,
		activeDate: merchant?.active_date,
		assignee: getFullName?.(merchant?.assignee),
		industryType: merchant?.industry_type,
		merchantId: merchant?.merchant_id,
		merchantName: merchant?.merchant_name,
		applicationStatus: merchant?.application_status,
		merchantStatus: merchant?.merchant_status,
		mid: merchant?.mid,
		openPendCount: merchant?.open_pend_count,
		processor: merchant?.processor,
		sponsor: merchant?.sponsor,
		startDate: merchant?.start_date,
		endDate: merchant?.end_date,
		startPendDate: merchant?.earliest_open_pend_date,
		isCompleteAllowed: merchant?.is_complete_allowed,
		priorityType: merchant?.priority_type,
		ageInInstallationInSeconds: merchant?.age_in_installation_in_seconds,
		hasAnyNotClosedPends: merchant?.has_any_not_closed_pends,
	};
};

export const mapTerminalsDataFromServer = terminals => {
	return terminals?.map(terminal => ({
		tidVNumber: terminal?.tid_v_number,
		orderNumber:
			terminal?.order_number?.toString() === "False"
				? ""
				: terminal?.order_number?.toString(),
		trackingNumber: terminal?.tracking_number,
		carrier: terminal?.carrier,
		terminalId: terminal?.id,
		terminalProgramType: terminal?.program_type?.value,
		terminalSolution: terminal?.terminal_solution,
		isIntegratedWithTsys: terminal?.is_integrated_with_tsys,
	}));
};

export const mapTerminalsDataToServer = terminals => {
	return terminals?.map(terminal => ({
		tid_v_number: terminal?.tidVNumber,
		order_number: terminal?.orderNumber,
		tracking_number: terminal?.trackingNumber,
		carrier: terminal?.carrier,
		terminalId: terminal?.terminalId,
	}));
};

// TODO: Use enum PendStatuses
export const getPendStatusName = type => {
	let name = "";
	switch (type) {
		case pendStatus.RESPONSE_SUBMITTED:
			name = "Response Submitted";
			break;
		case pendStatus.REOPEN:
			name = "Reopen";
			break;
		case pendStatus.CLOSED:
			name = "Closed";
			break;
		case pendStatus.OPEN:
			name = "Open";
			break;
		default:
			name = "Unassigned";
			break;
	}
	return name;
};
